define('app/collections/travel_hotel_collection',['app/setup', 'app/models/travel_plane_card'], function (takhfifan, planeCard) {

  takhfifan.TravelHotelCollection = Backbone.Collection.extend({
    model: takhfifan.PlaneCard,
    filters: {},
    tmpModels: [],
    fetch: function (options) {
      this.hasTakhfifan = false;
      this.hasIttic = false;
      this.fetchCallback = options.success;
      this.getModels({data: options.data, dataType: options.dataType, url: '/catalogsearch/ajax/hotelsearch'});
      this.getModels({data: options.data, dataType: options.dataType, url: '/api/hotel/get-hotels'});
    },
    fetchJustOnlineHotels: function (options) {
      this.hasTakhfifan = false;
      this.hasIttic = false;
      this.fetchCallback = options.success;
      this.getJustOnlineModels({data: options.data, dataType: options.dataType, url: '/api/hotel/get-hotels'});
    },
    getModels: function (options) {
      var _this = this;
      if (options && (options.url !== '/api/hotel/get-hotels' ||
        options.data && options.data.city_id !== '0')) {
        $.ajax(options).done(function (data, textStatus, jqXHR) {
          if (jqXHR.status == 204) {
            _this.getModels.call(_this, options);
          } else {
            if (options.url === '/api/hotel/get-hotels') {
              _this.hasIttic = true;
              _this.hasOnline = data.results && data.results.length > 0;
              _this.processResults(data.results || [], true, 'online');
            } else {
              _this.hasTakhfifan = true;
              if (options.data.city_id === '0') {
                _this.hasIttic = true;
              }
              _this.processResults(data || [], false, 'offline');
            }
          }
        }).fail(function () {
          if (options.url === '/api/hotel/get-hotels') {
            _this.hasIttic = true;
            _this.processResults([], true);
          } else {
            _this.hasTakhfifan = true;
            _this.processResults([], false);
          }
        }).always(function () {

        });
      }
    },

    getJustOnlineModels: function (options) {
      var _this = this;
      if (options && (options.url !== '/api/hotel/get-hotels' ||
        options.data && options.data.city_id !== '0')) {
        $.ajax(options).done(function (data, textStatus, jqXHR) {
          if (jqXHR.status == 204) {
            _this.getModels.call(_this, options);
          } else {
            if (options.url === '/api/hotel/get-hotels') {
              _this.hasIttic = true;
              _this.hasOnline = data.results && data.results.length > 0;
              _this.processJustOnlineResults(data.results || [], true, 'online');
            }
          }
        }).fail(function () {
          if (options.url === '/api/hotel/get-hotels') {
            _this.hasIttic = true;
            _this.processJustOnlineResults([], true);
          } else {
            _this.hasTakhfifan = true;
            _this.processJustOnlineResults([], false);
          }
        }).always(function () {

        });
      }
    },

    getRoomDetails: function (model, tmpModels, event) {
      var persistedData = Lockr.get('travelHotelData');
      var searchModel = null;
      if(model){
        searchModel = model;
      }
      else{
        searchModel = persistedData.search;
      }
      var _this = this;
      $.ajax({
        url: '/api/hotel/search-hotels',
        type: "GET",
        data: {
          checkin: searchModel.checkin,
          nights: searchModel.nights,
          city_id: searchModel.cityId,
          persons: searchModel.person
        }
      }).done(function (data) {
        if (data.results && data.results.length > 0) {
          _.each(data.results, function (hotelData) {
            var hotel = _.find(tmpModels, function (r) {
              return r.id == hotelData.hotelId;
            });
            if (hotel) {
              if (hotel.get('room') && hotel.get('room').length > 0) {
                var lowestRoom = hotel.get('room')[0];
                _.each(hotelData.room, function (completeRoom) {
                  var room = _.find(hotel.get('room'), function (r) {
                    return r.id == completeRoom.roomId;
                  });
                  if (room) {
                    _.extend(room, completeRoom);
                    var avPrices = _.reduce(room.detailPrice, function (mem, item) {
                      mem.rackRate += item.rackRate || 0;
                      mem.price += item.price || 0;
                      return mem;
                    });
                    room.avPrice = avPrices.price / room.detailPrice.length;
                    room.avRakRate = avPrices.rackRate / room.detailPrice.length;
                    room.price = avPrices.price;
                    room.rakRate = avPrices.rackRate;
                    room.disPercentage = Math.round(100 - (room.avPrice / room.avRakRate) * 100);
                    if (!lowestRoom.avPrice || lowestRoom.avPrice > room.avPrice) {
                      lowestRoom = room;
                    }
                  }
                });
                if (lowestRoom && lowestRoom.avPrice) {
                  hotel.set('discount_percentage', lowestRoom.disPercentage);
                  hotel.set('price', lowestRoom.price);
                  hotel.set('retail_price', lowestRoom.rakRate);
                }
              }
            }
          });
        }
        takhfifan.eventHub.trigger(event, {collection: _this});
      }).fail(function () {
        takhfifan.eventHub.trigger('message:show', {
          type: 'error',
          msg: "در برقراری ارتباط خطایی پیش آمد"
        });
      });
    },

    processResults: function (results, isIttic, type) {
      if (isIttic) {
        var tmpModels = [];
        this.ir = !!results.length;

        _.each(results, function (result) {
          var model = {
            id: result.id,
            name: result.description,
            type: result.type,
            isOnline: type === 'online' ? true : false,
            rate: parseInt(result.rate, 10),
            description: result.extraDescription || "",
            discount_percentage: 0,
            price: 0,
            retail_price: 0,
            vendor_rate: 0,//TODO #NEXT get from API
            instant_reservation: true,
            images: result.images,
            address: result.address1,
            phone: result.telForPassenger,
            latLng: result.pointOnMap,
            facilities: {
              carRental: result.carRental,
              airportService: result.airportService == "Paid" ? "1" : "0",
              restaurantBreakfastArea: result.restaurantBreakfastArea,
              lift: result.lift,
              laundry: result.laundry,
              smoking: result.smoking,
              petsAllow: result.petsAllow,
              disabledAccessibility: result.disabledAccessibility,
              parkingIndoor: result.parkingIndoor,
              poolAllYear: result.poolAllYear,
              parkingGuarantee: result.parkingGuarantee,
              parkingOutdoor: result.parkingOutdoor,
              poolChildren: result.poolChildren,
              poolFitness: result.poolFitness,
              poolHotSpring: result.poolHotSpring,
              poolIndoor: result.poolIndoor,
              poolJacuzzi: result.poolJacuzzi,
              poolMassage: result.poolMassage,
              poolMen: result.poolMen,
              poolSeasonal: result.poolSeasonal,
              poolSuana: result.poolSuana,
              poolWomen: result.poolWomen,
              poolOutdoor: result.poolOutdoor,
              restaurantSelfService: result.restaurantSelfService,
              restaurantBreakfastInRoom: result.restaurantBreakfastInRoom,
              restaurantRoofGarden: result.restaurantRoofGarden,
              restaurantRoomService: result.restaurantRoomService,
              poolComment: result.poolComment,
            },
            distanceFromPlace: result.otherFacilities,
            room: result.room
          };
          var hasAnyFacility = false;
          for (var element in model.facilities) {
            if (model.facilities[element] === "1") {
              hasAnyFacility = true;
            }
          }
          if (!hasAnyFacility) {
            model.facilities = null;
          }
          tmpModels.push(model);
        });
        this.tmpModels = _.union(this.tmpModels, tmpModels);
      } else {
        this.tmpModels = _.union(this.tmpModels, results);
      }
      if (this.hasTakhfifan && this.hasIttic) {
        this.reset(this.tmpModels);
        this.filters = {
          type: _.uniq(_.pluck(this.tmpModels, 'type')),
          rate: _.uniq(_.pluck(this.tmpModels, 'rate')),
          instant_reservation: this.ir
        };
        this.tmpModels = [];
        this.fetchCallback(this)
      }
    },

    processJustOnlineResults: function (results, isIttic, type) {
      if (isIttic) {
        var tmpModels = [];
        this.ir = !!results.length;

        _.each(results, function (result) {
          var model = {
            id: result.id,
            name: result.description,
            type: result.type,
            isOnline: type === 'online' ? true : false,
            rate: parseInt(result.rate, 10),
            description: result.extraDescription || "",
            discount_percentage: 0,
            price: 0,
            retail_price: 0,
            vendor_rate: 0,//TODO #NEXT get from API
            instant_reservation: true,
            images: result.images,
            address: result.address1,
            phone: result.telForPassenger,
            latLng: result.pointOnMap,
            facilities: {
              carRental: result.carRental,
              airportService: result.airportService == "Paid" ? "1" : "0",
              restaurantBreakfastArea: result.restaurantBreakfastArea,
              lift: result.lift,
              laundry: result.laundry,
              smoking: result.smoking,
              petsAllow: result.petsAllow,
              disabledAccessibility: result.disabledAccessibility,
              parkingIndoor: result.parkingIndoor,
              poolAllYear: result.poolAllYear,
              parkingGuarantee: result.parkingGuarantee,
              parkingOutdoor: result.parkingOutdoor,
              poolChildren: result.poolChildren,
              poolFitness: result.poolFitness,
              poolHotSpring: result.poolHotSpring,
              poolIndoor: result.poolIndoor,
              poolJacuzzi: result.poolJacuzzi,
              poolMassage: result.poolMassage,
              poolMen: result.poolMen,
              poolSeasonal: result.poolSeasonal,
              poolSuana: result.poolSuana,
              poolWomen: result.poolWomen,
              poolOutdoor: result.poolOutdoor,
              restaurantSelfService: result.restaurantSelfService,
              restaurantBreakfastInRoom: result.restaurantBreakfastInRoom,
              restaurantRoofGarden: result.restaurantRoofGarden,
              restaurantRoomService: result.restaurantRoomService,
              poolComment: result.poolComment,
            },
            distanceFromPlace: result.otherFacilities,
            room: result.room
          };
          var hasAnyFacility = false;
          for (var element in model.facilities) {
            if (model.facilities[element] === "1") {
              hasAnyFacility = true;
            }
          }
          if (!hasAnyFacility) {
            model.facilities = null;
          }
          tmpModels.push(model);
        });
        this.tmpModels = _.union(this.tmpModels, tmpModels);
      } else {
        this.tmpModels = _.union(this.tmpModels, results);
      }
      if (type === 'online') {
        this.reset(this.tmpModels);
        this.filters = {
          type: _.uniq(_.pluck(this.tmpModels, 'type')),
          rate: _.uniq(_.pluck(this.tmpModels, 'rate')),
          instant_reservation: this.ir
        };
        this.tmpModels = [];
        this.fetchCallback(this)
      }
    }
  });

});

